import styled from 'styled-components';

export const HistoryDropdownChildWrapper = styled.div`
  width: 228px;
  padding: 20px;
  padding-right: 15px;

  .wrapper {
    margin-bottom: 20px;
  }

  .text {
    font-size: 14px;
    line-height: 17px;
    color: #566F75;
  }

  .date {
    font-size: 12px;
    line-height: 14px;
    color: #B1B1B1;
  }
`;
